import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Link, type LinkProps } from 'react-router-dom'
import { btn, type BtnSize, type BtnVariant } from '../../lib/ui'

type CommonProps = {
  variant?: BtnVariant
  size?: BtnSize
  className?: string
  children: ReactNode
}

export function Button({
  variant = 'default',
  size = 'md',
  className,
  children,
  ...props
}: CommonProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type="button" className={btn(variant, size, className)} {...props}>
      {children}
    </button>
  )
}

export function ButtonLink({
  variant = 'default',
  size = 'md',
  className,
  children,
  ...props
}: CommonProps & LinkProps) {
  return (
    <Link className={btn(variant, size, className)} {...props}>
      {children}
    </Link>
  )
}
